"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "COPYABLE_TEXT_BUTTON_SIZE", {
  enumerable: true,
  get: function get() {
    return _ButtonIcon.BUTTON_ICON_SIZE;
  }
});
Object.defineProperty(exports, "COPYABLE_TEXT_BUTTON_VISIBILITY", {
  enumerable: true,
  get: function get() {
    return _CopyableText.COPYABLE_TEXT_BUTTON_VISIBILITY;
  }
});
Object.defineProperty(exports, "COPYABLE_TEXT_ICON_NAME", {
  enumerable: true,
  get: function get() {
    return _Icon.ICON_NAME;
  }
});
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Icon = require("b2b-components/theme/components/Icon");
var _CopyableText = require("../CopyableText");